<div
  *ngIf="notification"
  [auraRibbonColor]="notification.type === 'error' ? 'danger' : 'success'"
  auraRibbon
  auraRibbonPosition="top"
  class="notification"
>
  <div
    [ngClass]="
      notification.type === 'success'
        ? 'notification__success-message'
        : 'notification__error-message'
    "
    role="alert"
    id="notification-focus"
    tabindex="0"
    aria-labelledby="notification-label"
  >
    <aura-icon
      [content]="icon"
      class="notification__icon"
      data-cy="error-notification-icon"
    ></aura-icon>
    <div>
      <span
        [innerHTML]="notification.message"
        class="notification__message"
        data-cy="error-notification-label"
        id="notification-label"
      ></span>
      <a
        (click)="scrollTo(notification.focusItem, $event)"
        *ngIf="notification.errors"
        data-cy="error-notification-link"
        [innerHTML]="notification.errors"
        [linkSize]="'medium'"
        auraLink
        href="#"
      ></a>
    </div>
  </div>
</div>
